import React from "react";
import "./chipTabs.css";

export interface ChipTabItem {
    key: string;
    label: string;
}

interface ChipTabsProps {
    tabs: ChipTabItem[];
    activeKey: string;
    onChange: (key: string) => void;

    // Optional Props
    className?: string;
    chipClassName?: string;
    activeChipClassName?: string;
    scrollable?: boolean;
}

const ChipTabs: React.FC<ChipTabsProps> = ({
    tabs,
    activeKey,
    onChange,
    className = "",
    chipClassName = "",
    activeChipClassName = "",
    scrollable = true
}) => {
    return (
        <div
            className={`chip-tabs-container ${scrollable ? "scrollable" : ""} ${className}`}
        >
            {tabs.map((tab) => {
                const isActive = tab.key === activeKey;

                return (
                    <button
                        key={tab.key}
                        onClick={() => onChange(tab.key)}
                        className={`chip-tab ${isActive ? "chip-active" : ""
                            } ${isActive ? activeChipClassName : chipClassName}`}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default ChipTabs;
